import { render, staticRenderFns } from "./ClientSummary.vue?vue&type=template&id=eb4bf596&scoped=true&"
import script from "./ClientSummary.vue?vue&type=script&lang=js&"
export * from "./ClientSummary.vue?vue&type=script&lang=js&"
import style0 from "./ClientSummary.vue?vue&type=style&index=0&id=eb4bf596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb4bf596",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VFlex,VIcon,VSkeletonLoader,VSpacer})
